var render = function render(){var _vm=this,_c=_vm._self._c;return _c('acclaro-pagination',{attrs:{"show-first-page":_vm.handleFirst,"show-previous-page":_vm.handlePrevious,"show-next-page":_vm.handleNext,"show-last-page":_vm.handleLast,"pagination-details":_vm.paginationDetails}})
}
var staticRenderFns = []

export { render, staticRenderFns }